import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoFranquiaInserirRoutingModule } from './chamado-franquia-inserir-routing.module';
import { ChamadoFranquiaInserirComponent } from './chamado-franquia-inserir.component';
import { FormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ChamadoFranquiaInserirComponent
  ],
  imports: [
    CommonModule,
    ChamadoFranquiaInserirRoutingModule,
    FormsModule,
    MessagesModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    InputTextareaModule,
    TooltipModule,
    ProgressSpinnerModule

  ]
})
export class ChamadoFranquiaInserirModule { }
